import { render, staticRenderFns } from "./registrationInvitation.vue?vue&type=template&id=4eb212af&scoped=true&"
import script from "./registrationInvitation.vue?vue&type=script&lang=js&"
export * from "./registrationInvitation.vue?vue&type=script&lang=js&"
import style0 from "./registrationInvitation.vue?vue&type=style&index=0&id=4eb212af&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb212af",
  null
  
)

export default component.exports